module.exports = __webpack_public_path__ + "img/li.9509b991.svg";